"use client";

import { useEffect } from "react";

import { kickCable, pauseCable } from "@/api/cable";

export function CableRescue() {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        kickCable();
      } else {
        pauseCable();
      }
    };

    window.addEventListener("online", kickCable);
    window.addEventListener("offline", pauseCable);
    window.addEventListener("focus", kickCable);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      window.removeEventListener("online", kickCable);
      window.removeEventListener("offline", pauseCable);
      window.removeEventListener("focus", kickCable);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
}
